
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class DtdcApiDetailsDialog extends Serenity.EntityDialog<DtdcApiDetailsRow, any> {
        protected getFormKey() { return DtdcApiDetailsForm.formKey; }
        protected getIdProperty() { return DtdcApiDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return DtdcApiDetailsRow.localTextPrefix; }
        protected getNameProperty() { return DtdcApiDetailsRow.nameProperty; }
        protected getService() { return DtdcApiDetailsService.baseUrl; }
        protected getDeletePermission() { return DtdcApiDetailsRow.deletePermission; }
        protected getInsertPermission() { return DtdcApiDetailsRow.insertPermission; }
        protected getUpdatePermission() { return DtdcApiDetailsRow.updatePermission; }

        protected form = new DtdcApiDetailsForm(this.idPrefix);

    }
}